module.exports = __webpack_public_path__ + "img/2.3ae2a80c.webp";